import React from 'react';
export const DMP_LOGO_URL = 'https://cdn.magicpatterns.com/uploads/tyxhEMSMkUXVRzttuJLN7u/dhaka-metropolitan-police-seeklogo.png';
interface DMPLogoProps {
  size?: number;
  className?: string;
}
export function DMPLogo({
  size = 48,
  className = ''
}: DMPLogoProps) {
  return <img src={DMP_LOGO_URL} alt="ঢাকা মেট্রোপলিটন পুলিশ লোগো" width={size} height={size} style={{
    width: size,
    height: size
  }} className={`shrink-0 object-contain ${className}`} data-id="element-169" data-mp="jnaxbnqafqis" />;
}